/* eslint-disable block-scoped-var,no-param-reassign,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

xplenty.directive('cloudStorageDelimiter', [
  '$timeout',
  'ComponentEditorListeners',
  function ($timeout, ComponentEditorListeners) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./cloud-storage-delimiter.html'),

      replace: true,

      scope: {
        component: '=',
        settings: '=',
      },

      link(scope, element, attrs) {
        scope.lineInside = attrs.lineInside === 'true';
        scope.showCustomDelimiterInput = false;
        scope.customDelimiter = ',';
        scope.fieldDelimiter = ',';

        const fieldDelimiter = scope.settings.field_delimiter;
        const textQualifier = scope.settings.text_qualifier;
        var escapeCharacter = scope.settings.escape_character;
        var lineEnding = scope.settings.line_ending;

        scope.fieldDelimiterOptions = [
          { value: ',', text: ',' },
          { value: '\\t', text: '\\t (Tab)' },
          { value: '\\u0001', text: '\\u0001' },
          { value: 'space', text: 'Space' },
          { value: '\\n', text: '\\n (New Line)' },
          { value: 'custom', text: 'Custom' },
        ];

        if (scope.fieldDelimiterOptions.find((option) => option.value === fieldDelimiter) || fieldDelimiter === ' ') {
          scope.fieldDelimiter = fieldDelimiter === ' ' ? 'space' : fieldDelimiter;
        } else {
          scope.fieldDelimiter = 'custom';
          scope.customDelimiter = fieldDelimiter;
          scope.showCustomDelimiterInput = true;
        }

        if (scope.settings.write_header !== undefined) {
          var writeHeader = scope.settings.write_header;
        }

        if (scope.settings.skip_header !== undefined) {
          var skipHeader = scope.settings.skip_header;
        }

        scope.isLineEndingLabelVisible = () =>
          scope.component &&
          scope.component.componentType === 'cloud_storage_destination_component' &&
          scope.settings.text_qualifier !== '';

        scope.isEscapeCharacterDropdownVisible = scope.settings.text_qualifier !== '';

        scope.onFieldDelimiterChange = (fieldDelimiterValue) => {
          scope.fieldDelimiter = fieldDelimiterValue;

          if (fieldDelimiterValue === 'custom') {
            scope.showCustomDelimiterInput = true;
            scope.settings.field_delimiter = scope.customDelimiter;
          } else {
            scope.showCustomDelimiterInput = false;
            scope.settings.field_delimiter = fieldDelimiterValue;
          }
        };

        scope.onCustomDelimiterChange = (customDelimiter) => {
          if (customDelimiter === undefined) {
            scope.showDelimiterErrorMessage = true;
          } else {
            scope.showDelimiterErrorMessage = false;
            scope.customDelimiter = customDelimiter;
            scope.settings.field_delimiter = customDelimiter;
          }
        };

        scope.onTextQualifierChange = (textQualifierValue) => {
          scope.settings.text_qualifier = textQualifierValue;
          scope.isEscapeCharacterDropdownVisible = textQualifierValue !== '';
        };

        const isCloudStorageDestinationComponent =
          scope.component && scope.component.componentType === 'cloud_storage_destination_component';

        scope.textQualifierOptions = [
          {
            value: '',
            text: 'cloud-storage-source-editor.form.selects.string_qualifier.options.none',
            translate: true,
          },
          {
            value: 'quoted_multi_line',
            text: 'cloud-storage-source-editor.form.selects.string_qualifier.options.double_quote_newline_inside',
            translate: true,
          },
          !isCloudStorageDestinationComponent ? { value: '"', text: '"' } : null,
          {
            value: 'single_quoted_multi_line',
            text: 'cloud-storage-source-editor.form.selects.string_qualifier.options.single_quote_newline_inside',
            translate: true,
          },
          !isCloudStorageDestinationComponent ? { value: "'", text: "'" } : null,
          { value: 'enforce_double_quotes', text: '"' },
          { value: 'enforce_single_quotes', text: "'" },
          isCloudStorageDestinationComponent
            ? {
                value: '"',
                text:
                  'cloud-storage-destination-editor.form.selects.string_qualifier.options.double_quote_contains_delimiter_or_line_break',
                translate: true,
              }
            : null,
          isCloudStorageDestinationComponent
            ? {
                value: "'",
                text:
                  'cloud-storage-destination-editor.form.selects.string_qualifier.options.single_quote_contains_delimiter_or_line_break',
                translate: true,
              }
            : null,
        ].filter(Boolean);

        scope.onEscapeCharacterChange = (escapeCharacterValue) => {
          scope.settings.escape_character = escapeCharacterValue;
        };

        scope.escapeCharacterOptions = [
          { value: '"', text: '"' },
          { value: "'", text: "'" },
          { value: '\\', text: '\\' },
        ];

        if (scope.settings.escape_character == null || scope.settings.escape_character === 'none') {
          scope.settings.escape_character = '"';
        }

        if (!scope.fieldDelimiterOptions.find((item) => item.value === scope.settings.field_delimiter)) {
          scope.fieldDelimiterOptions = [
            ...scope.fieldDelimiterOptions,
            {
              value: scope.settings.field_delimiter,
              text: scope.settings.field_delimiter,
            },
          ];
        }

        if (!scope.escapeCharacterOptions.find((item) => item.value === scope.settings.escape_character)) {
          scope.escapeCharacterOptions = [
            ...scope.escapeCharacterOptions,
            {
              value: scope.settings.escape_character,
              text: scope.settings.escape_character,
            },
          ];
        }

        if (!scope.lineInside) {
          scope.textQualifierOptions = scope.textQualifierOptions.filter(
            (item) => item.value !== 'quoted_multi_line' && item.value !== 'single_quoted_multi_line',
          );
        } else {
          scope.textQualifierOptions = scope.textQualifierOptions.filter(
            (item) => item.value !== 'enforce_double_quotes' && item.value !== 'enforce_single_quotes',
          );
          scope.escapeCharacterOptions = scope.escapeCharacterOptions.filter((item) => item.value !== 'none');
        }

        if (scope.settings && scope.settings.field_delimiter === ' ') scope.settings.field_delimiter = 'space';
        if (scope.settings && (scope.settings.escape_character === 'none' || scope.settings.escape_character === '')) {
          scope.settings.escape_character = '"';
        }
        if (scope.settings && scope.settings.text_qualifier === 'none') {
          scope.settings.text_qualifier = '';
        }
        if (!scope.settings.line_ending) scope.settings.line_ending = 'unix';

        const onCancelCallback = function () {
          setModelValues();
          mapSettings();
        };
        const onSaveSuccessCallback = function () {
          mapSettings();
        };

        ComponentEditorListeners.onCancel(onCancelCallback);
        ComponentEditorListeners.onSaveSuccess(onSaveSuccessCallback);

        scope.$on('$destroy', function () {
          ComponentEditorListeners.clearOnSaveSuccessCb(onSaveSuccessCallback);
          ComponentEditorListeners.clearOnCancelCb(onCancelCallback);
        });

        function mapSettings() {
          if (scope.settings && scope.settings.field_delimiter === 'space') scope.settings.field_delimiter = ' ';
          if (
            scope.settings &&
            (scope.settings.escape_character === 'none' || scope.settings.escape_character === '')
          ) {
            scope.settings.escape_character = '"';
          }
        }

        function setModelValues() {
          if (scope.settings && scope.settings.text_qualifier) scope.settings.text_qualifier = textQualifier;
          if (scope.settings && scope.settings.field_delimiter) scope.settings.field_delimiter = fieldDelimiter;
          if (scope.settings && scope.settings.escape_character) scope.settings.escape_character = escapeCharacter;
          if (scope.settings && scope.settings.line_ending) scope.settings.line_ending = lineEnding;
          if (scope.settings && scope.settings.write_header !== undefined) scope.settings.write_header = writeHeader;
          if (scope.settings && scope.settings.skip_header !== undefined) scope.settings.skip_header = skipHeader;
        }
      },

      controller: [
        '$scope',
        function ($scope) {
          $scope.lineInside = false;
        },
      ],
    };
  },
]);
